import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { isNull } from "lodash";

export const EmergencyContactContext = createContext(null);

export const EmergencyContactProvider = ({ children }) => {
  const [emergencyContactDetails, setEmergencyContactDetails] = useState();

  const memoizedValue = useMemo(
    () => ({
      emergencyContactDetails,
      setEmergencyContactDetails,
    }),
    [emergencyContactDetails]
  );

  return (
    <EmergencyContactContext.Provider value={memoizedValue}>
      {children}
    </EmergencyContactContext.Provider>
  );
};

export const useEmergencyContactContext = () => {
  const context = useContext(EmergencyContactContext);

  if (!context)
    throw new Error(
      "useEmergencyContactContext context must be use inside EmergencyContactProvider"
    );

  return context;
};

EmergencyContactProvider.propType = {
  children: PropTypes.node,
};

// ----------------------------------------------------------------------
